import { render, staticRenderFns } from "./ModalReordenacaoDocumento.vue?vue&type=template&id=434aa59d&scoped=true"
import script from "./ModalReordenacaoDocumento.vue?vue&type=script&lang=js"
export * from "./ModalReordenacaoDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434aa59d",
  null
  
)

export default component.exports